import { render } from "./EditArticle.vue?vue&type=template&id=bb8cffb0&scoped=true&ts=true"
import script from "./EditArticle.vue?vue&type=script&lang=ts"
export * from "./EditArticle.vue?vue&type=script&lang=ts"

import "./EditArticle.vue?vue&type=style&index=0&id=bb8cffb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb8cffb0"]])

export default __exports__